export enum POPUP_FONT_PROVIDER {
    BROWSER = 'browser',
    GOOGLE = 'google',
    CUSTOM = 'custom'
}
